/**
 * Checks if the input string is non-null/undefined/empty/contains only whitespace.
 * @param input String to check
 * @returns True if the string fails to pass the check, false otherwise.
 */
export const isNullOrWhiteSpace = (
  input: string | undefined | null
): input is undefined | null => !input || !input.trim();

/**
 * Replaces placeholders ({0}, {1}, etc.) in a string with provided values.
 */
export const replacePlaceholders = (str: string, ...values: string[]): string =>
  str.replace(/{(\d+)}/g, (_, index) => values[Number(index)] ?? `{${index}}`);

export const firstCharToLower = (value: string) => {
  const [first, ...rest] = value;

  if (first) {
    return `${first.toLowerCase()}${rest.join("")}`;
  } else {
    return "";
  }
};
